import {
  fetchCurrentUser,
  fetchCurrentUserStarted,
  fetchCurrentUserSuccess,
  fetchCurrentUserFailure,
  logoutUser,
} from './actions.js';
import reducers, { initialState } from './reducers.js';
import {
  selectCurrentUser,
  selectUserRole,
  selectAllowedSpecIds,
  selectUserEnvironment,
  selectAuthLoading,
  selectAuthError,
  selectIsAdmin,
  selectIsEditor,
  selectIsViewer,
  selectIsViewerEnv,
  selectIsViewerOrViewerEnv,
  selectDefaultSpecId,
} from './selectors.js';
import { setupAxiosAuthInterceptor } from './axiosAuthInterceptor.js';
import { consumeTokenFromFragment } from './oauth2Service.js';
import TopBarWrapper from './wrap-components/TopBarWrapper.jsx';
import TopBarEnvironmentIndicatorWrapper from './wrap-components/TopBarEnvironmentIndicatorWrapper.jsx';
import UrlSpecHandlerWrapper from './wrap-components/UrlSpecHandlerWrapper.jsx';
import ReadOnlySelectionWrapper from './wrap-components/ReadOnlySelectionWrapper.jsx';

// Start token exchange from URL fragment ASAP (before React renders).
// This is async but kicks off the fetch immediately; AuthInitializer awaits the result.
consumeTokenFromFragment();

// Setup Axios interceptor on plugin load
setupAxiosAuthInterceptor();

const AuthPlugin = () => ({
  statePlugins: {
    pagoAuth2: {
      initialState,
      actions: {
        fetchCurrentUser,
        fetchCurrentUserStarted,
        fetchCurrentUserSuccess,
        fetchCurrentUserFailure,
        logoutUser,
      },
      reducers,
      selectors: {
        selectCurrentUser,
        selectUserRole,
        selectAllowedSpecIds,
        selectUserEnvironment,
        selectAuthLoading,
        selectAuthError,
        selectIsAdmin,
        selectIsEditor,
        selectIsViewer,
        selectIsViewerEnv,
        selectIsViewerOrViewerEnv,
        selectDefaultSpecId,
      },
    },
  },
  wrapComponents: {
    TopBar: TopBarWrapper,
    TopBarEnvironmentIndicator: TopBarEnvironmentIndicatorWrapper,
    UrlSpecHandler: UrlSpecHandlerWrapper,
    ReadOnlySelection: ReadOnlySelectionWrapper,
  },
});

export default AuthPlugin;
